module.exports = __webpack_public_path__ + "img/kr.c498a82b.svg";